var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-wrapper"},[_c('CustHeaderComp',{attrs:{"title":"Site Settings"}}),_c('StoreOpenSettings'),_c('DeliverySettings'),_c('StoreHours'),_c('CustomerHeader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }